import script from "./CategoriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesView.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesView.vue?vue&type=style&index=0&id=8d368702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d368702"]])

export default __exports__